import { InternalMessageType } from '../../enums';
import { InternalMessagePayloadValidator } from '../../types';
import { InternalCloseDialogPayload } from './types';

export const internalCloseDialogPayloadValidator: InternalMessagePayloadValidator<
  InternalMessageType.CloseDialog
> = (payload: unknown): payload is InternalCloseDialogPayload =>
  typeof payload === 'undefined';
